import { dayjs } from '../../support/helpers/dayjs.ts';
import { CSSProperties } from 'react';
import { formatLocalDateShort } from '../../support/helpers/format.ts';
import { IDailyForecast } from '../model/IDailyForecast.ts';

export const DayHeading: React.FC<{forecast: IDailyForecast, highlightDay: string}> = ({forecast, highlightDay}) => {

    const diff = dayjs(highlightDay).diff(dayjs(forecast.forecastStart), 'h');
    const isHighlighted = (diff >= 0 && diff < 24);

    const style: CSSProperties = {
        borderRadius: 10,
        marginLeft: -10,
        paddingLeft: 10,
        paddingRight: 10,
        paddingTop: 1,
        fontSize: 14,
        fontWeight: 'bold',
        color: (isHighlighted ? 'white' : undefined),
        backgroundColor: (isHighlighted ? 'var(--ion-color-primary' : undefined)
    };

    return (
        <span style={style}>
            {formatLocalDateShort({ date: forecast.forecastStart, location: forecast.location })}
        </span>
    );
};
